export default __webpack_public_path__ + "img/f0398edd15e0e05e59bd233b29c5cfff.gif";